export const getTimeValue = (time: number) =>
  time > 0 ? `${time < 10 ? 0 : ""}${time}` : "00";
